module.exports = __webpack_public_path__ + "img/bg.5fc19825.png";